type Calendar = {
  year: number;
  month: number;
  date: number;
};

type JapaneseEraDuration = {
  // 和暦開始年月日
  began: Readonly<Calendar>;
  // 和暦終了年月日
  end?: Readonly<Calendar>;
};

const Showa: Readonly<JapaneseEraDuration> = {
  began: {
    year: 1926,
    month: 12,
    date: 26,
  },
  end: {
    year: 1989,
    month: 1,
    date: 7,
  },
};

const Heisei: Readonly<JapaneseEraDuration> = {
  began: {
    year: 1989,
    month: 1,
    date: 8,
  },
  end: {
    year: 2019,
    month: 4,
    date: 30,
  },
};

const Reiwa: Readonly<JapaneseEraDuration> = {
  began: {
    year: 2019,
    month: 5,
    date: 1,
  },
};

const switchWareki = (ad: number) => {
  if (ad >= Reiwa.began.year) {
    // 2019〜
    return "令和";
  }
  if (ad > Heisei.began.year) {
    // 1990〜2018
    return "平成";
  }
  if (ad > Showa.began.year) {
    // 1927〜1989
    return "昭和";
  }
  // 〜1926
  return "大正";
};

/**
 * 引数をもとに「XX元年」を返す
 * @param year
 * @param month
 */
const getFirstJapaneseEra = (year: number, month?: number) => {
  if (year === Showa.began.year) {
    if (!month || month === Showa.began.month) {
      // month が指定されていない場合、
      // または12月だけ昭和元年になりえる
      return "昭和元年";
    }
    return "";
  }
  if (year === Heisei.began.year) {
    if (month && month > Heisei.began.month) {
      // month が指定されている場合、1月以降は組み込み処理の表示で問題ないため何も返さない
      return "";
    }
    return "平成元年";
  }
  if (year === Reiwa.began.year) {
    if (month) {
      // month が指定されていれば組み込みの処理で問題ないため何も返さない
      return "";
    }
    return "令和元年";
  }
  return "";
};

export const toIncludeJapaneseCalendar = (
  ad: string | number | undefined,
  isYearOnly = false,
  defaultValue: string | number = "-"
) => {
  const options = { era: "long" };
  const tmp = String(ad).match(/(\d{4})-(\d{1,2})/);
  const exclude = /(年\d{1,2}月\d{1,2}日)/;
  const japaneseEraRegexp = /^(大正|昭和|平成|令和)/;
  if (tmp) {
    const year = parseInt(tmp[1], 10);
    const month = parseInt(tmp[2], 10);
    // IE/safariなどで日付が残るためsplitで除却する
    let japaneseCalendar = Intl.DateTimeFormat("ja-JP-u-ca-japanese", options)
      .format(new Date(tmp[0]))
      .split("/")[0];
    if (exclude.test(japaneseCalendar)) {
      japaneseCalendar = japaneseCalendar.replace(exclude, "");
    }
    if (!japaneseEraRegexp.test(japaneseCalendar)) {
      japaneseCalendar = `${switchWareki(year)}${japaneseCalendar}`;
    }
    const firstJapaneseEra = isYearOnly ? getFirstJapaneseEra(year) : getFirstJapaneseEra(year, month);
    if (firstJapaneseEra.length > 0) {
      // 改元された年、月の場合、改元前と改元後の元号が入り混じるため両方表示する
      return `${year}年 （${japaneseCalendar}年/${firstJapaneseEra}） ${month}月`;
    }
    return `${year}年 （${japaneseCalendar}年） ${month}月`;
  }
  return defaultValue;
};

export default toIncludeJapaneseCalendar;
